<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="content-grid">
            <div style="display: flex; justify-content: space-between;">
                <h2 class="content-block">Countries</h2>
            </div>
            <!--
                when we have time we need to continue to add edit/delete popup on reuse-grid component 
                <app-country-grid>
            </app-country-grid> -->

            <dx-data-grid class="dx-card wide-card" [dataSource]="countryDataSource" [showBorders]="false"
                [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true"
                keyExpr="Id">
                <dxo-paging [pageSize]="15"></dxo-paging>
                <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
                <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
                    <dxo-popup title="Service Info" [showTitle]="true" [width]="700" [height]="525">
                    </dxo-popup>
                    <dxo-paging [pageSize]="10"></dxo-paging>
                    <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-form>
                        <dxi-item dataField="Name" [colSpan]="2">
                            <dxi-validation-rule type="required" message="Name is required">
                            </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="Description" editorType="dxTextArea" [colSpan]="2"
                            [editorOptions]="{ height: 100 }">
                        </dxi-item>
                    </dxo-form>
                </dxo-editing>
                <dxi-column dataField="Name" caption="Name">
                </dxi-column>
                <dxi-column dataField="Description" caption="Description">
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>
</div>